import { useState } from "react";
import Popup from "./Popup";
import { FormInput } from "./FormInput";
import { FormTextarea } from "./FormTextArea";
import { FormSelect } from "./FormSelect";

export default function GenerateLicenseModal({
  isOpen,
  onClose,
  onSubmit,
  initialData = {},
}) {
  const [formData, setFormData] = useState({
    tier: "basic",
    durationDays: 30,
    customer: {
      email: "",
      name: "",
      phone: "",
      address: "",
    },
    // Legacy fields for backward compatibility
    customerEmail: "",
    customerName: "",
    purchaseAmount: "",
    ...initialData,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleInputChange = (field, value, isCustomerField = false) => {
    if (isCustomerField) {
      setFormData((prev) => ({
        ...prev,
        customer: {
          ...prev.customer,
          [field]: value,
        },
        // Update legacy fields for backward compatibility
        ...(field === "email" && { customerEmail: value }),
        ...(field === "name" && { customerName: value }),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  if (!isOpen) return null;

  return (
    <Popup popupTitle="Generate New License" onClose={onClose} width="max-w-md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <FormSelect
          label="Tier"
          required
          value={formData.tier}
          onChange={(e) => handleInputChange("tier", e.target.value)}
          options={[
            { label: "Basic", value: "basic" },
            { label: "Whatsapp", value: "whatsapp" },
            { label: "AI Only", value: "ai_only" },
            { label: "AI and Whatsapp", value: "ai_and_whatsapp" },
          ]}
        />

        <FormInput
          label="Duration (Days)"
          type="number"
          required
          min={1}
          value={formData.durationDays}
          onChange={(e) =>
            handleInputChange("durationDays", parseInt(e.target.value))
          }
        />

        <FormInput
          label="Customer Name"
          required
          value={formData.customer.name}
          onChange={(e) => handleInputChange("name", e.target.value, true)}
          placeholder="John Doe"
        />

        <FormInput
          label="Customer Email"
          type="email"
          required
          value={formData.customer.email}
          onChange={(e) => handleInputChange("email", e.target.value, true)}
          placeholder="john@example.com"
        />

        <FormInput
          label="Customer Phone"
          type="tel"
          required
          value={formData.customer.phone}
          onChange={(e) => {
            // Only allow digits and limit to 10 digits
            const value = e.target.value.replace(/\D/g, "").slice(0, 10);
            handleInputChange("phone", value, true);
          }}
          placeholder="1234567890"
          maxLength={10}
          pattern="[0-9]{10}"
        />

        <FormTextarea
          label="Customer Address"
          value={formData.customer.address}
          onChange={(e) => handleInputChange("address", e.target.value, true)}
          placeholder="123 Main St, City, State, ZIP"
        />


        <FormInput
          label="Purchase Amount"
          type="number"
          step="0.01"
          required
          value={formData.purchaseAmount}
          onChange={(e) => handleInputChange("purchaseAmount", e.target.value)}
          placeholder="99.99"
        />

        <div className="flex gap-3 pt-4">
          <button
            type="submit"
            className="flex-1 px-4 py-2 bg-slate-900 text-white rounded-lg hover:bg-slate-800 font-medium transition-colors"
          >
            Generate
          </button>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-slate-200 rounded-lg text-slate-700 hover:bg-slate-50 font-medium transition-colors"
          >
            Cancel
          </button>
        </div>
      </form>
    </Popup>
  );
}
